/*
 * Galerie na produktu ukazuje jen fotky zvolene barvy.
 * Mapu media ID → barvy pripravuje snippet 'mol-variant-media'.
 */
(function () {
  const HIDDEN_CLASS = 'mol-media-hidden';

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function mediaIdFrom(value) {
    return (value || '').split('-').pop();
  }

  class MolVariantMedia {
    constructor(dataScript) {
      this.sectionId = dataScript.dataset.section;

      let data;
      try {
        data = JSON.parse(dataScript.textContent);
      } catch (error) {
        return;
      }

      this.colorIndex = data.colorIndex;
      this.mediaColors = new Map();
      Object.keys(data.media || {}).forEach((id) => {
        this.mediaColors.set(id, (data.media[id] || []).map(normalize));
      });
      if (!this.mediaColors.size) return;

      this.gallery = document.getElementById(`MediaGallery-${this.sectionId}`);
      this.viewer = document.getElementById(`GalleryViewer-${this.sectionId}`);
      this.thumbs = document.getElementById(`GalleryThumbnails-${this.sectionId}`);
      this.modalContent = document.querySelector(`#ProductModal-${this.sectionId} .product-media-modal__content`);
      this.picker = document.querySelector(
        `variant-radios[data-section="${this.sectionId}"], variant-selects[data-section="${this.sectionId}"]`
      );
      this.initialStyle = document.getElementById(`MolVariantMediaStyle-${this.sectionId}`);
      if (!this.picker || !this.viewer) return;

      document.addEventListener('change', (event) => {
        if (this.picker.contains(event.target)) this.apply();
      });

      this.apply();
    }

    selectedColor() {
      const fieldsets = this.picker.querySelectorAll('fieldset');
      if (fieldsets.length) {
        const fieldset = fieldsets[this.colorIndex];
        const checked = fieldset ? fieldset.querySelector('input:checked') : null;
        return checked ? normalize(checked.value) : '';
      }

      const selects = this.picker.querySelectorAll('select');
      const select = selects[this.colorIndex];
      return select ? normalize(select.value) : '';
    }

    matchesColor(mediaId, color) {
      const colors = this.mediaColors.get(mediaId);
      if (!colors || !colors.length) return true;
      return colors.indexOf(color) !== -1;
    }

    /* Dawn schovava fotky variant vlastnim CSS · od ted o viditelnosti rozhoduje tenhle skript */
    releaseDawnHiding() {
      if (this.released) return;
      this.released = true;

      document
        .querySelectorAll(
          `#MainProduct-${this.sectionId} .product__media-item--variant, #MainProduct-${this.sectionId} .thumbnail-list_item--variant`
        )
        .forEach((element) => {
          element.classList.remove('product__media-item--variant');
          element.classList.remove('thumbnail-list_item--variant');
        });
    }

    apply() {
      const color = this.selectedColor();
      if (!color) return;

      if (this.initialStyle) {
        this.initialStyle.remove();
        this.initialStyle = null;
      }
      this.releaseDawnHiding();

      this.viewer.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => {
        item.classList.toggle(HIDDEN_CLASS, !this.matchesColor(mediaIdFrom(item.dataset.mediaId), color));
      });

      if (this.thumbs) {
        this.thumbs.querySelectorAll('[data-target]').forEach((item) => {
          item.classList.toggle(HIDDEN_CLASS, !this.matchesColor(mediaIdFrom(item.dataset.target), color));
        });
      }

      if (this.modalContent) {
        Array.from(this.modalContent.children).forEach((item) => {
          if (!item.dataset.mediaId) return;
          item.classList.toggle(HIDDEN_CLASS, !this.matchesColor(item.dataset.mediaId, color));
        });
      }

      this.ensureActiveMediaVisible();
      this.refreshSliders();
    }

    ensureActiveMediaVisible() {
      const active = this.viewer.querySelector('.product__media-item.is-active');
      if (active && !active.classList.contains(HIDDEN_CLASS)) return;

      const first = this.viewer.querySelector(`.product__media-item:not(.${HIDDEN_CLASS})`);
      if (!first || !this.gallery || typeof this.gallery.setActiveMedia !== 'function') return;

      this.gallery.setActiveMedia(first.dataset.mediaId, true);
    }

    refreshSliders() {
      [this.viewer, this.thumbs].forEach((slider) => {
        if (slider && typeof slider.resetPages === 'function') slider.resetPages();
      });

      const visibleMedia = this.viewer.querySelectorAll(`.product__media-item:not(.${HIDDEN_CLASS})`).length;

      const buttons = this.viewer.querySelector('.slider-buttons');
      if (buttons) buttons.classList.toggle(HIDDEN_CLASS, visibleMedia < 2);

      /* Dawn pocita slajdy podle sirky · na desktopu je videt jen aktivni, proto pocitadlo dopocitam sam */
      const current = this.viewer.querySelector('.slider-counter--current');
      const total = this.viewer.querySelector('.slider-counter--total');
      if (current && total) {
        const visibleItems = Array.from(this.viewer.querySelectorAll(`.product__media-item:not(.${HIDDEN_CLASS})`));
        const activeIndex = visibleItems.findIndex((item) => item.classList.contains('is-active'));
        total.textContent = visibleItems.length;
        current.textContent = activeIndex < 0 ? 1 : activeIndex + 1;
      }

      if (this.thumbs) {
        const visibleThumbs = this.thumbs.querySelectorAll(`[data-target]:not(.${HIDDEN_CLASS})`).length;
        this.thumbs.classList.toggle(HIDDEN_CLASS, visibleThumbs < 2);
      }
    }
  }

  function init() {
    document.querySelectorAll('script[data-mol-variant-media]').forEach((dataScript) => {
      if (dataScript.dataset.molReady) return;
      dataScript.dataset.molReady = 'true';
      new MolVariantMedia(dataScript);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
